import { Input, Label, SearchIcon, Text } from '@fluentui/react-northstar';
import { useBoolean } from '@uifabric/react-hooks';
import { IContextualMenuProps } from 'office-ui-fabric-react';
import { List } from 'office-ui-fabric-react/lib/List';
import { IStackTokens, Stack, StackItem } from 'office-ui-fabric-react/lib/Stack';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import BookmarkSidepanelContainer from '../../components/Bookmark-Sidepanel';
import Loader from '../../components/Loader';
import { HubFile, Story } from '../../model';
import { useTypedSelector } from '../../store';
import { ApplicationState } from '../../store/appThunkAction';
import { searchContent } from '../../store/Search/actions';
import PopularContent from '../Search/popularcontent';
import styles from './index.module.scss';
import SearchFileItem from './searchfileitem';
import SearchStoryItem from './searchstoryItem';


const SearchContentInMeeting = ({
    renderBookmarks,
    onSelectionChange,
    overRideListHeight,
}: {
    renderBookmarks: boolean,
    overRideListHeight?:boolean,
    onSelectionChange: (files: {
        fileId: number;
        storyId: number;
    }[]) => void;
}) => {
    const dispatch = useDispatch();
    const {
        currentMeeting
    } = useTypedSelector((state: ApplicationState) => state.meeting);

    const [isFileselected, { toggle: toggleisFileselected }] = useBoolean(true);
    const {
        files: fileFromSearch,
        stories: fromSearch,
        searchProgress
    } = useTypedSelector((state: ApplicationState) => state.search);
    const [selectedStoryIds, updateSelectedStortIds] = React.useState([] as number[]);
    const [selectedFileIds, updateSelectedFileIds] = React.useState([] as {
        fileId: number;
        storyId: number
    }[]);

    const [stories, updateStories] = React.useState(fromSearch);
    const [files, updateFiles] = React.useState(fileFromSearch);
    const [selectedCacheStories, updateSelectedCacheStories] = React.useState([] as any[]);
    const [searchTem, setSearchTerm] = React.useState('');
    const [sortyType, setSortType] = React.useState('Relevance');
    const onSearchChange = (term: string) => {
        setSearchTerm(term);
        if (term && term.length > 0) {
            dispatch(searchContent(term, isFileselected ? 'files' : 'stories', sortyType));
            updateSelectedStortIds([]);
        }
    };
    const search = (e: React.MouseEvent<HTMLLabelElement>) => {
        e.preventDefault();
        if (searchTem && searchTem.length > 0) {
            dispatch(searchContent(searchTem, !isFileselected ? 'files' : 'stories', sortyType));
        }
        toggleisFileselected();
    }

   // const stackTokens: Partial<IStackTokens> = { childrenGap: 20 };
    const onFileItemClick = (fileId: number, storyId: number) => {
        if (selectedFileIds.find(c => c.fileId === fileId)) {
            const tmpIds = selectedFileIds.filter(c => c.fileId !== fileId);
            updateSelectedFileIds(tmpIds);
            onSelectionChange && onSelectionChange(tmpIds)
        } else {
            const tmpIds = [...selectedFileIds, {
                fileId,
                storyId
            }];
            updateSelectedFileIds(tmpIds);
            onSelectionChange && onSelectionChange(tmpIds)
        }
        updateFiles([...files]);
    };
    const onFileRenderCell = (item: HubFile | undefined): JSX.Element => {
        if (!item) {
            return <></>
        }
        let isFound = false;
        if (currentMeeting.meetingContents)
            isFound = !!currentMeeting.meetingContents.find(c => c.fileId === item.id);
        return <SearchFileItem disable={isFound} checked={!!selectedFileIds.find(c => c.fileId === item.id) || isFound} onItemClick={onFileItemClick} {...item} />
    };
    const notifyStorySelectionChange = (ids: number[]) => {
        const dataToSend: {
            fileId: number;
            storyId: number;
        }[] = [];
        ids.forEach((id) => {
            const currentStory = selectedCacheStories.find(c => c.permId === id);
            if (currentStory) {
                (currentStory.files || []).forEach((item: any) => {
                    dataToSend.push({
                        fileId: item.id,
                        storyId: currentStory.permId
                    });
                });
            }
        });
        onSelectionChange && onSelectionChange(dataToSend)
    };
    const onStoryClick = (storyId: number) => {
        if (selectedStoryIds.indexOf(storyId) >= 0) {
            const tmpIds = selectedStoryIds.filter(c => c !== storyId);
            updateSelectedStortIds(tmpIds);
            notifyStorySelectionChange(tmpIds);
        } else {
            const tmpIds = [...selectedStoryIds, storyId];
            updateSelectedStortIds(tmpIds);
            notifyStorySelectionChange(tmpIds);
        }
        updateStories([...stories]);

    }
    const onStoryRenderCell = (item: Story | undefined): JSX.Element => {
        if (!item) {
            return <></>
        }
        let isFound = false;
        if (currentMeeting.meetingContents)
            isFound = !!currentMeeting.meetingContents.find(c => c.storyId === item.permId);
        return <SearchStoryItem disable={isFound} checked={!!selectedStoryIds.find(c => c === item.permId) || isFound} onItemClick={onStoryClick} {...item} />
    };
    React.useEffect(() => {
        if (searchTem && searchTem.length > 0) {
            dispatch(searchContent(searchTem, isFileselected ? 'files' : 'stories', sortyType));
        }
    }, [sortyType]);

    React.useEffect(() => {
        updateStories(fromSearch);
        updateSelectedCacheStories([
            ...selectedCacheStories,
            ...fromSearch
        ]);
    }, [fromSearch])

    React.useEffect(() => {
        updateFiles(fileFromSearch.filter(c => !!c.coverArt));
    }, [fileFromSearch])

    const renderSearch = () => {
        return (
            <>
                <Stack className={`${styles.selectionContainer} ${renderBookmarks ? `${styles.selectionContainerBookmarks}` : `${styles.selectionContainerPopular}`}`} horizontal>
                    <StackItem className={styles.files}>
                        <Label className={`${styles.label} ${isFileselected ? `${styles.selectedOption}` : `${styles.unSelectedOption}`}`} onClick={search} id="files">
                            Files
                        </Label>
                        {isFileselected &&
                            <hr className={styles.divider} style={{ left: 0 }} />
                        }
                    </StackItem>
                    <StackItem className={styles.stories}>
                        <Label className={`${styles.label} ${!isFileselected ? `${styles.selectedOption}` : `${styles.unSelectedOption}`}`} onClick={search} id="stories">
                            Stories
                        </Label>
                        {!isFileselected &&
                            <hr className={styles.divider} />
                        }
                    </StackItem>
                    <Stack className={styles.dialogTitle}>
                        <Text>
                            {searchTem && `${isFileselected ? files.length : stories.length} ${isFileselected ? 'Files' : 'Stories'} matching "${searchTem}"`}
                        </Text>
                    </Stack>
                </Stack>
                <Stack.Item grow={1} className={`${!overRideListHeight ? `${styles.list}` : `${styles.overRideList}`}`}>
                    {!isFileselected && <List items={stories} onRenderCell={onStoryRenderCell} />}
                    {isFileselected && <List items={files} onRenderCell={onFileRenderCell} />}
                </Stack.Item>
            </>
        )
    }
    return (
        <Stack className={styles.root}>
            {searchProgress && <div className={styles.loader}><Loader /></div>}
            <Input className={styles.search} fluid icon={<SearchIcon />} clearable placeholder="Search" onKeyDown={(event) => {
                event.key === "Enter" && onSearchChange((event.target as any).value)
            }} />
            {searchTem && searchTem.length > 0 && renderSearch()}
            {!searchTem && renderBookmarks && <BookmarkSidepanelContainer />}
            {!searchTem && !renderBookmarks &&
                <Stack>
                    <PopularContent onSelectionChange={(data) => onSelectionChange && onSelectionChange(data)} />
                </Stack>}
        </Stack>
    );

};
export default SearchContentInMeeting;